<ng-template>
  <div
    (click)="closed.emit()"
    class="tw-flex tw-flex-col tw-bg-background tw-border tw-border-solid tw-rounded tw-border-secondary-500 tw-bg-clip-padding tw-py-2 tw-shrink-0"
    role="menu"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
